import * as React from 'react';
import cx from 'classnames';
import { Icon, OSCIconNames } from '@dx-ui/osc-icon';
import { useBrandConfig } from '@dx-ui/global-ui-prism';

export type ControlNextProps = {
  /** used for screen readers and other assistive devices */
  label: string;
  /** the size of the control */
  size?: React.ComponentProps<typeof Icon>['size'];
  /** to set alternate icon names for brand specific icons */
  iconName?: OSCIconNames;
} & React.ComponentProps<'button'>;

/**
 * A simple button to be used any time you need an interaction to go forward. like for pagination.
 */
export const ControlNext = ({
  className,
  disabled,
  label,
  size = 'md',
  iconName = 'arrowhead-right',
  ref: forwardedRef,
  ...rest
}: ControlNextProps) => {
  const brandConfig = useBrandConfig();
  const isSurfaceEnabled = brandConfig.surfaceConfig.isEnabled;
  return (
    <button
      ref={forwardedRef}
      type="button"
      className={cx('border-0 rtl:-scale-x-100', className, {
        'btn !p-0 text-current': !isSurfaceEnabled,
        'btn--base btn--brand btn--flat bg-transparent': isSurfaceEnabled,
      })}
      disabled={disabled}
      {...rest}
    >
      <span className="sr-only">{label}</span>
      <Icon name={iconName} size={size} />
    </button>
  );
};

ControlNext.displayName = 'ControlNext';

export default ControlNext;
